<template>
  <input-popover v-model:open="isDetailsOpen" class="z-30" :position="'bottom-end'">
    <template #trigger>
      <div
        class="hidden items-center justify-between space-x-2 rounded-full bg-gray-700 p-1 sm:flex"
        :class="[{ 'pl-5': !advisor.telephone }, hasDetails ? 'hover:bg-gray-600' : 'pr-5']"
      >
        <a
          v-if="advisor.telephone"
          :href="`tel:${advisor.telephone}`"
          data-cy="funding-advisor-phone"
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full hover:bg-gray-500"
          @click.stop
        >
          <icon-phone class="text-green-500" />
        </a>
        <div
          data-cy="funding-advisor-name"
          class="flex flex-col"
          :class="{ 'cursor-pointer': hasDetails }"
        >
          <span class="text-sm text-branding-heading">
            {{ advisor.first_name }} {{ advisor.last_name }}
          </span>
          <span class="text-xs text-gray-400">{{ $t("role.fundingAdvisor") }}</span>
        </div>
        <button
          v-if="hasDetails"
          data-cy="funding-advisor-details-toggle"
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full"
        >
          <icon-arrow fill="currentColor" :class="isDetailsOpen ? '-rotate-90' : 'rotate-90'" />
        </button>
      </div>
    </template>
    <template #content>
      <platform-contact-details
        v-if="hasDetails"
        :advisor="advisor"
        @close="isDetailsOpen = false"
      />
    </template>
  </input-popover>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import IconArrow from "@/components/icons/IconArrow.vue";
import IconPhone from "@/components/icons/IconPhone.vue";
import InputPopover from "@/components/input/InputPopover.vue";
import PlatformContactDetails from "@/components/platform/PlatformContactDetails.vue";
import type { FundingAdvisor } from "@/api/http/schemas/applicationSchemas";

const { advisor } = defineProps<{
  advisor: FundingAdvisor;
}>();

const isDetailsOpen = ref(false);

const hasDetails = computed(() => Boolean(advisor.telephone || advisor.calendar_link));
</script>
